import React, { FC, memo } from 'react';
import { faCloudDownload } from '@fortawesome/pro-light-svg-icons';
import { downloadFile } from '../../../util/download';
import FnButtonIcon from '../FnButtonIcon';
import { DivWrapper } from './styles';

interface Props {
  uri: string;
  label?: string;
  className?: string;
}

const FnButtonDownload: FC<Props> = ({ uri, label, className = '' }) => {
  const handleClick = () => downloadFile(uri);

  return (
    <DivWrapper className={className} onClick={handleClick}>
      <FnButtonIcon icon={faCloudDownload} text={label} />
    </DivWrapper>
  );
};

export default memo(FnButtonDownload);
